<div class="container">
    <iframe class="responsive-iframe" [src]="iframeSrc"></iframe>
</div>